var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGirl6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1300,
    height: 1300,
    viewBox: "0 0 1300 1300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M650 1300C290.71 1300 0 1008.86 0 650C0 290.71 291.141 0 650 0C1009.29 0 1300 291.141 1300 650C1300.43 1009.29 1009.29 1300 650 1300Z",
    fill: "#BAC6A2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_226_2207",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1301,
    height: 1300
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M650 1300C290.71 1300 0 1008.86 0 650C0 290.71 291.141 0 650 0C1009.29 0 1300 291.141 1300 650C1300.43 1009.29 1009.29 1300 650 1300Z",
    fill: "#F7C0B5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_226_2207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1014 1197.33C1010.97 1199.5 1007.5 1201.66 1004.47 1203.83C1001 1206 997.967 1208.16 994.5 1209.9C991.467 1211.63 988.867 1213.36 985.834 1215.1C985.4 1215.53 984.967 1215.53 984.534 1215.96C974.567 1222.03 964.167 1227.66 953.767 1232.86C950.734 1234.6 947.267 1236.33 944.234 1237.63C944.234 1237.63 943.8 1238.06 943.367 1238.06C939.9 1239.8 936.434 1241.53 932.967 1243.26C926.034 1246.73 918.667 1249.76 911.734 1252.8C908.267 1254.53 904.367 1255.83 900.9 1257.13C897.434 1258.43 893.534 1260.16 890.067 1261.46C886.6 1262.76 882.7 1264.5 879.234 1265.8C879.234 1265.8 879.234 1265.8 878.8 1265.8C875.334 1267.1 871.434 1268.4 867.967 1269.7C860.167 1272.3 851.934 1274.9 844.134 1277.5C841.534 1278.36 838.5 1279.23 835.9 1280.1C827.667 1282.7 819.434 1284.86 811.2 1286.6C808.167 1287.46 805.134 1287.9 801.667 1288.76C793.867 1290.5 785.634 1292.23 777.834 1293.96C776.1 1294.4 774.8 1294.4 773.067 1294.83C770.467 1295.26 767.434 1295.7 764.834 1296.13C760.934 1296.56 757.467 1297.43 753.567 1297.86C751.834 1298.3 750.1 1298.3 748.367 1298.73C746.2 1299.16 743.6 1299.6 741 1299.6C734.067 1300.46 726.7 1301.33 719.767 1302.2C717.6 1302.63 715 1302.63 712.834 1303.06H712.4C709.367 1303.5 706.334 1303.5 703.3 1303.93C700.267 1304.36 697.234 1304.36 694.2 1304.36C692.467 1304.36 690.3 1304.8 688.567 1304.8C685.1 1304.8 682.067 1305.23 679.034 1305.23C674.7 1305.23 670.8 1305.66 666.467 1305.66C662.134 1305.66 658.234 1305.66 653.9 1305.66C650.867 1305.66 647.834 1305.66 644.8 1305.66C462.367 1303.06 297.7 1225.5 180.7 1102.43C180.7 1102.43 180.7 1102 180.267 1102C193.7 1075.56 243.534 1027.9 295.534 988.465C361.4 938.632 454.567 907.865 454.567 907.865C454.567 907.865 515.667 897.898 742.3 945.132C915.2 981.532 988.867 1129.3 1014 1197.33Z",
    fill: "#F7D3B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790.401 1065.16C781.301 1109.8 722.367 1136.23 623.134 1096.36C501.367 1046.96 454.567 907.865 454.567 907.865C448.067 808.198 432.901 722.832 432.901 722.832C573.734 710.698 740.134 875.365 740.134 875.365L759.201 956.832C760.934 963.765 764.401 969.832 769.601 974.165C778.701 989.765 796.467 1036.56 790.401 1065.16Z",
    fill: "#F7D3B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.6 974.598C686.833 970.265 625.733 958.132 560.3 840.698C615.767 889.665 681.2 908.298 750.1 916.965L759.2 956.832C760.934 964.198 764.4 970.265 769.6 974.598Z",
    fill: "#EFBDA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940.767 452.432C948.567 488.832 952.467 518.298 931.234 615.365C910 712.432 950.734 809.498 848.467 898.332C779.567 958.132 659.1 969.398 562.9 903.965C530.4 881.865 500.5 851.098 476.234 810.798C457.167 779.165 435.067 749.265 410.367 721.965C376.134 684.698 334.967 609.732 355.334 477.132C388.267 261.332 601.9 236.632 728 260.465C854.1 284.298 919.534 356.232 940.767 452.432Z",
    fill: "#F7D3B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.067 621.865C526.067 621.865 512.633 556.865 449.367 564.665C394.767 571.598 375.7 702.465 499.633 738.865",
    fill: "#F7D3B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.734 679.498C495.734 679.498 480.134 669.532 481.867 652.198C484.467 631.832 481.867 619.265 472.334 615.365C448.501 605.398 443.734 633.132 444.601 636.598",
    stroke: "#423232",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826.367 721.532C826.367 721.532 842.833 722.398 858.433 703.765C867.1 693.365 874.467 680.365 869.7 676.465C864.933 672.132 786.5 684.265 781.3 694.665C776.1 705.065 806.433 721.532 826.367 721.532Z",
    fill: "#EFBDA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M839.367 575.932C839.367 575.932 840.234 617.098 866.667 663.032C878.367 683.398 860.601 716.765 822.034 722.398",
    stroke: "#423232",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M604.501 743.632C629.151 743.632 649.134 727.141 649.134 706.798C649.134 686.456 629.151 669.965 604.501 669.965C579.85 669.965 559.867 686.456 559.867 706.798C559.867 727.141 579.85 743.632 604.501 743.632Z",
    fill: "#ED938A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M924.3 670.832C923 695.098 923.434 718.932 921.7 742.765C902.634 738.432 888.767 724.132 888.767 707.232C888.767 689.032 903.934 674.298 924.3 670.832Z",
    fill: "#ED938A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.233 1030.03C872.299 1000.13 828.966 965.034 758.766 946.834C681.199 926.467 640.899 970.234 578.933 964.167C545.566 960.7 490.966 895.7 454.133 905.234C408.633 917.367 358.366 941.634 297.699 983.667C284.699 992.767 173.333 1067.3 134.766 1189.07C99.666 1299.13 90.9993 1450.8 90.1327 1501.07H1077.27C1077.7 1189.93 939.466 1061.23 905.233 1030.03Z",
    fill: "#5E84F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.832 956.367C439.832 956.367 431.599 884.434 438.966 861.467C439.832 858.434 448.932 853.234 448.932 853.234C448.932 853.234 448.932 893.534 546.432 921.267C649.132 950.3 763.532 941.634 784.766 932.534C784.766 932.534 785.199 992.334 773.932 1014.87C756.599 1049.53 618.799 1042.17 535.166 1013.57C461.932 988.434 439.832 956.367 439.832 956.367Z",
    fill: "#5E84F0"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M36.3997 1010.97C124.366 962.434 112.666 1012.7 240.5 988C295.1 977.6 356.633 929.934 435.066 926.467C494.866 923.867 561.166 963.734 634.833 968.934C696.366 973.267 767.433 941.634 838.5 953.334C900.466 963.3 957.666 1015.3 1027 1032.2",
    stroke: "#6D5F5E",
    strokeWidth: 21.7052,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M38.1327 1060.37C133.033 1020.93 117.866 1070.77 247.866 1049.53C304.633 1040.43 368.766 992.334 448.066 988.867C510.033 986.267 578.066 1026.57 653.033 1030.47C716.733 1033.93 788.666 999.7 861.033 1009.67C925.166 1018.33 985.399 1070.33 1056.03 1085.5",
    stroke: "#6D5F5E",
    strokeWidth: 21.7052,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M39.8667 1109.77C140.4 1078.57 122.2 1127.53 254.8 1110.2C313.3 1102.4 380.033 1054.3 460.633 1050.83C524.333 1048.23 594.967 1089.4 670.8 1092.43C736.667 1095.03 809.467 1058.2 883.567 1066.43C949.867 1073.8 1013.13 1125.37 1085.5 1138.37",
    stroke: "#6D5F5E",
    strokeWidth: 21.7052,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M41.5996 1159.17C146.9 1135.77 126.533 1183.87 261.733 1170C322.4 1163.5 391.733 1115.4 473.633 1112.37C539.5 1109.77 611.866 1152.23 689.433 1153.97C757.466 1155.7 831.566 1116.7 906.966 1123.2C975.866 1129.27 1042.17 1179.97 1115.83 1191.23",
    stroke: "#6D5F5E",
    strokeWidth: 21.7052,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M42.8998 1209C152.1 1192.1 130 1240.2 267.366 1229.37C330.2 1224.6 402.133 1176.07 485.333 1173.47C553.366 1171.3 627.9 1214.63 706.333 1215.93C776.533 1216.8 851.933 1175.63 928.633 1180.4C999.7 1184.73 1069.47 1235 1144.87 1243.67",
    stroke: "#6D5F5E",
    strokeWidth: 21.7052,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M43.7662 1258.83C156.433 1248 133.033 1295.67 272.566 1288.3C337.566 1284.83 412.1 1236.73 497.033 1235C567.233 1233.27 643.5 1277.9 723.666 1278.33C796.033 1278.77 873.166 1235 950.733 1238.47C1024.83 1241.5 1097.63 1290.9 1173.9 1296.53",
    stroke: "#6D5F5E",
    strokeWidth: 21.7052,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M45.0664 1309.1C160.766 1303.9 136.066 1351.13 278.633 1347.23C345.366 1345.5 422.933 1297.4 509.6 1296.1C581.966 1295.23 660.4 1340.73 741.866 1340.73C816.833 1340.73 895.266 1295.23 974.133 1296.53C1050.83 1297.83 1127.1 1346.37 1204.67 1349.4",
    stroke: "#6D5F5E",
    strokeWidth: 21.7052,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "M315.466 975C332.366 994.067 401.699 1076.83 426.399 1170.43L482.299 1179.53C482.299 1179.53 422.499 1030.47 340.166 957.667C336.699 954.634 331.499 954.2 327.166 955.934C323.699 957.667 319.366 960.7 315.466 965.9C312.866 968.934 313.299 972.834 315.466 975Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.566 1150.93C844.566 1150.93 851.933 1039.13 796.033 960.267C796.033 960.267 799.5 956.8 819 966.334C832.866 972.834 873.6 1028.73 877.5 1141.83C877.933 1141.83 849.333 1151.37 844.566 1150.93Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.4 1092.87C413.4 1092.87 733.633 1178.23 871.866 1083.77C871.866 1083.77 943.8 1225.47 971.966 1501.07H354.9C354.9 1501.07 405.166 1434.77 413.4 1092.87Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.899 1198.6C483.387 1198.6 492.699 1189.29 492.699 1177.8C492.699 1166.31 483.387 1157 471.899 1157C460.412 1157 451.099 1166.31 451.099 1177.8C451.099 1189.29 460.412 1198.6 471.899 1198.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M856.7 1165.67C866.752 1165.67 874.9 1157.52 874.9 1147.47C874.9 1137.42 866.752 1129.27 856.7 1129.27C846.648 1129.27 838.5 1137.42 838.5 1147.47C838.5 1157.52 846.648 1165.67 856.7 1165.67Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.042 526.549C752.576 527.849 759.942 517.883 756.476 508.349C754.742 503.149 751.709 498.383 746.942 495.349C732.209 486.249 677.176 485.383 648.142 506.183C622.576 525.249 699.709 520.482 743.042 526.549Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.074 531.316C855.274 531.316 850.508 521.349 854.408 513.116C856.574 508.782 859.608 504.882 863.941 502.716C877.374 496.216 913.341 500.116 929.374 522.216C943.674 541.716 899.041 530.882 863.074 531.316Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.875 581.149C694.075 595.449 656.375 577.682 656.375 577.682",
    stroke: "#423232",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.042 589.816C899.042 589.816 875.642 604.116 846.175 587.216",
    stroke: "#423232",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.331 773.797C801.497 778.564 796.297 769.03 779.397 777.264C767.264 782.897 760.764 784.63 746.031 775.964C736.497 769.897 724.797 778.564 713.531 762.097",
    stroke: "#423232",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942.154 452.634C940.854 446.134 939.121 439.2 936.954 432.7C934.788 426.2 929.588 420.567 922.654 419.267C900.121 415.367 878.454 426.634 847.254 422.3C748.021 408.867 681.721 366.834 588.554 403.234C492.354 440.5 546.954 595.634 526.588 619.467C523.121 607.334 506.221 557.934 450.754 564.867C398.321 571.367 378.388 692.7 486.721 734.3C485.854 758.134 442.954 780.667 408.288 739.067C373.621 697.467 304.288 589.567 351.088 431.834C397.888 274.1 609.788 191.767 806.954 271.934C840.754 285.8 862.421 315.7 890.588 325.667C948.221 346.9 948.654 483.834 942.154 452.634Z",
    fill: "#E58600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.154 734.734C487.154 734.734 486.288 770.267 449.888 836.134C449.888 836.134 441.221 799.734 422.154 766.367C403.521 733 366.688 663.234 344.154 593.467C321.621 523.7 363.221 610.367 384.454 639.4C405.254 668 419.121 739.067 487.154 734.734Z",
    fill: "#E58600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.054 699.634C426.054 699.634 413.921 780.667 491.487 882.934C569.054 985.2 573.387 1090.07 544.787 1201C544.787 1201 499.721 1167.63 363.221 1069.7C226.721 971.767 193.787 804.5 373.187 646.767C373.621 646.767 424.321 656.3 426.054 699.634Z",
    fill: "#E58600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.754 349.934C752.787 359.901 770.121 366.401 788.754 367.701C811.721 369.434 845.954 385.034 896.221 430.534C955.587 484.267 926.121 132.834 556.487 216.034C429.954 244.201 339.821 356.001 324.221 481.234C323.354 489.901 322.487 498.567 322.054 507.234C318.587 622.501 411.754 723.034 411.754 723.034C411.754 723.034 373.621 562.701 460.721 496.401C539.587 436.167 594.621 365.534 663.521 365.534C705.121 365.101 727.221 344.301 736.754 349.934Z",
    fill: "#E58600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940.42 576.567C940.42 576.567 994.587 545.801 991.554 469.101C988.52 392.401 948.22 444.401 948.22 444.401C948.22 444.401 952.554 511.567 940.42 576.567Z",
    fill: "#E58600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.544 705.467V779.134",
    stroke: "#FFDE55",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.044 877.934C514.344 889.634 498.311 897 480.111 897C445.011 897 415.978 868.4 415.978 832.867C415.978 797.767 444.578 768.734 480.111 768.734C497.878 768.734 514.344 776.1 526.044 787.8C518.244 783.467 509.578 780.867 500.044 780.867C471.444 780.867 448.044 804.267 448.044 832.867C448.044 861.467 471.444 884.867 500.044 884.867C509.578 885.3 518.244 882.7 526.044 877.934Z",
    fill: "#FFDE55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.544 858.867C481.664 858.867 493.111 847.42 493.111 833.3C493.111 819.18 481.664 807.734 467.544 807.734C453.424 807.734 441.978 819.18 441.978 833.3C441.978 847.42 453.424 858.867 467.544 858.867Z",
    fill: "#5E84F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M961.978 788.667C954.178 784.334 945.511 781.734 935.978 781.734C929.045 781.734 922.978 783.034 916.911 785.634C917.778 780.434 919.078 775.234 919.511 770.034C936.411 770.467 951.145 777.401 961.978 788.667Z",
    fill: "#FFDE55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M962.411 877.934C950.711 889.634 934.677 897 916.477 897C898.277 897 881.377 889.2 869.677 876.634C876.611 868.834 882.677 861.034 888.311 853.234C896.111 871.867 914.744 884.434 935.977 884.434C945.511 885.3 954.611 882.7 962.411 877.934Z",
    fill: "#FFDE55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M929.478 833.301C929.478 847.601 918.211 858.867 903.911 858.867C898.278 858.867 893.078 857.134 888.745 853.667C898.711 838.934 906.078 823.767 910.845 809.034C921.245 811.634 929.478 821.601 929.478 833.301Z",
    fill: "#5E84F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.764 568.726C933.1 641.3 921.764 767 921.764 767C921.764 767 1060.32 435.436 948.216 309.736C853.744 203.484 650 311.634 650 311.634C650 311.634 841.148 242.38 878.307 374.721C912.316 494.254 916.095 452.987 926.802 524.138C928.377 531.253 920.189 558.765 921.764 568.726Z",
    fill: "#E58600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M786 371.733C786 371.733 694.059 568.146 522.643 507.31C522.643 507.31 489.295 390.418 561.913 345.66C634.843 301.337 768.547 332.624 786 371.733Z",
    fill: "#E58600"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirl6);
export default __webpack_public_path__ + "static/media/Girl_6.705a8b78309945d471d27ca49dd2e72a.svg";
export { ForwardRef as ReactComponent };